import React from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import _ from "lodash"
import PostCard from "./../../../components/PostCardSmall/postCard"

import {
  RelatedPostWrapper3,
  RelatedPostItems3,
  RelatedPostTitle3,
  RelatedPostItem3,
} from "./../../../templates/templates.style"


type CategoryPostProps = {}

const CategoryPost: React.FunctionComponent<CategoryPostProps> = props => {
  const Data = useStaticQuery(graphql`
  query {
    cat1: allContentfulBlogPost(
      limit: 4
      sort: { fields: datePosted, order: DESC }
      filter: { category: { in: "motivation" } }
    ) {
      totalCount
      edges {
        node {
          postBody {
            childMarkdownRemark {
              excerpt(pruneLength: 300)
            }
          }
          slug
          datePosted(formatString: "DD [<span>] MMMM [</span>]")
          postTitle
          category
          postImage {
            file {
              url
            }
            fluid(quality: 90, maxWidth: 1170) {
              ...GatsbyContentfulFluid
            }
          }
        }
      }
    }
    cat2: allContentfulBlogPost(
      limit: 4
      sort: { fields: datePosted, order: DESC }
      filter: { category: { in: "fitness" } }
    ) {
      totalCount
      edges {
        node {
          postBody {
            childMarkdownRemark {
              excerpt(pruneLength: 300)
            }
          }
          slug
          datePosted(formatString: "DD [<span>] MMMM [</span>]")
          postTitle
          category
          postImage {
            file {
              url
            }
            fluid(quality: 90, maxWidth: 1170) {
              ...GatsbyContentfulFluid
            }
          }
        }
      }
    }
    cat3: allContentfulBlogPost(
      limit: 4
      sort: { fields: datePosted, order: DESC }
      filter: { category: { in: "health" } }
    ) {
      totalCount
      edges {
        node {
          postBody {
            childMarkdownRemark {
              excerpt(pruneLength: 300)
            }
          }
          slug
          datePosted(formatString: "DD [<span>] MMMM [</span>]")
          postTitle
          category
          postImage {
            file {
              url
            }
            fluid(quality: 90, maxWidth: 1170) {
              ...GatsbyContentfulFluid
            }
          }
        }
      }
    }
  }
  `)
  console.log(Data)



  const edges1 = Data.cat1.edges
  const edges2 = Data.cat2.edges
  const edges3 = Data.cat3.edges

  return (
        <RelatedPostWrapper3>
          <RelatedPostTitle3> <Link to={`/tags/${_.kebabCase('motivation')}/`} style={{color: '#D10068'}}>Motivation</Link> </RelatedPostTitle3>
          <RelatedPostItems3>
            {edges1.map(({ node }: any) => (
              <RelatedPostItem3 key={node.slug}>
                <PostCard
                  title={node.postTitle}
                  url={node.slug}
                  image={node.postImage.fluid}
                  tags={node.category}
                />
              </RelatedPostItem3>
            ))}
          </RelatedPostItems3>
          <RelatedPostTitle3><Link to={`/tags/${_.kebabCase('fitness')}/`} style={{color: '#D10068'}}>Fitness </Link></RelatedPostTitle3>
          <RelatedPostItems3>
            {edges2.map(({ node }: any) => (
              <RelatedPostItem3 key={node.slug}>
                <PostCard
                  title={node.postTitle}
                  url={node.slug}
                  image={node.postImage.fluid}
                  tags={node.category}
                />
              </RelatedPostItem3>
            ))}
          </RelatedPostItems3>
          <RelatedPostTitle3><Link to={`/tags/${_.kebabCase('health')}/`} style={{color: '#D10068'}}>Health </Link></RelatedPostTitle3>
          <RelatedPostItems3>
            {edges3.map(({ node }: any) => (
              <RelatedPostItem3 key={node.slug}>
                <PostCard
                  title={node.postTitle}
                  url={node.slug}
                  image={node.postImage.fluid}
                  tags={node.category}
                />
              </RelatedPostItem3>
            ))}
          </RelatedPostItems3>
        </RelatedPostWrapper3>
  )
}

export default CategoryPost

